const employeeStatuses = {
  active: 'employee_active',
  terminated: 'employee_terminated',
  timeoffManagedByMe: 'timeoff_managed_by_me',
  locationIssues: 'location_issues',
  reportingToMe: 'reporting_to_me',
  reportingToMeDirectly: 'reporting_to_me_directly',
  away: 'away',
  awayThisMonth: 'away_this_month',
  clockIn: 'clockIn',
  onBreak: 'onBreak',
  missingClockIn: 'missingClockIn',
  alertsAllTypes: 'alertsAllTypes',
  forgotToClockIn: 'forgotToClockIn',
  missingClockOut: 'missingClockOut',
  missingBreakTime: 'missingBreakTime',
  insufficientBreak: 'insufficientBreak',
  withWelcomeSpaceAccess: 'withWelcomeSpaceAccess',
} as const

export type EmployeeStatus = (typeof employeeStatuses)[keyof typeof employeeStatuses]

export default employeeStatuses
